










import ReportWrapper from '@/modules/report_server/infra/ReportWrapper.vue';
import { AnexoIProvider, AnexoIData } from './OtorgamientoRep';
import { ApiCompanyRepository } from '../ApiCompanyRepository';

export default {
    name: "report-otorgamiento",
    components: {
        ReportWrapper,
    },

    props: {
        reportData: {
            type: Object,
            required: false,
            default: null
        }
    },

    data() {
        return {
            contentProvider: null,

        };
    },

    created() {
        this.loadReportData();
    },

    methods: {
        async loadReportData() {
            try {
                const urlParams = new URLSearchParams(window.location.search);
                let some_uuid =  urlParams.get('uuid');
                let company_id =  urlParams.get('company_id');
                
                // Llamar ApiCompanyRepository
                const companyRepo = new ApiCompanyRepository();
                const data = await companyRepo.getPdfRepresentation( // fallo
                    Number(company_id),
                    some_uuid
                );
                // Crear el provider con los datos
                if (data) {
                    this.contentProvider = new AnexoIProvider(data);
                }

            } catch (error) {
                console.error('[ReportOtorgamiento] Error al cargar los datos del reporte:', error);
            }
        }
    }
};
